import reducer from "./reducer";
export { default as EvaluationProcessDefinitionAssignment } from "./components/index";
export { default as evaluationProcessDefinitionAssignmentReducerName } from "./constants";
export default reducer;
